import React, { useState } from "react";
import { Box, Typography, Button, CircularProgress, Card, List, ListItem, ListItemText, Divider, useTheme } from "@mui/material";
import Header from "../../components/Header";
import { getAuth } from "firebase/auth";
import { useAccount } from "../../common/AccountContext";
import { useUser } from "../../common/UserContext";
import { PLANS } from "../../planConfig";
import { createStripeCustomerPortalSession, createDodoPaymentsCustomerPortalSession, createPaddleCustomerPortalSession } from "../../common/FunctionCalls";
import { tokens } from "../../theme";

import { paymentProcessor } from "../../planConfig";

const capitalize = (str) => str ? str.charAt(0).toUpperCase() + str.slice(1) : "";

const Subscriptions = () => {
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const auth = getAuth();
  const {
    accountSubscriptionType,
    accountSubscriptionPlan,
    accountStripeCustomerId,
    accountDodoCustomerId,
    accountPaddleCustomerId,
    accountPaddleSubscriptionId,
    accountSubscriptionFrequency,
    accountStatus
  } = useAccount();
  const { appUserAccountNumber, appUserRole } = useUser();

  const goToCustomerPortal = async () => {
    setLoading(true);
    try {
      if (appUserRole === "admin") {
        
        switch (paymentProcessor) {
            case "stripe":
                const sessionIdInfo = await createStripeCustomerPortalSession(
                  accountStripeCustomerId,
                  "/subscriptions",
                  auth
                );
                if (sessionIdInfo.url) {
                  window.location.href = sessionIdInfo.url;
                }

              break;

            case "dodopayments":
                const sessionIdDodoInfo = await createDodoPaymentsCustomerPortalSession(
                  accountDodoCustomerId,
                  "/subscriptions",
                  auth
                );
                if (sessionIdDodoInfo.url) {
                  //window.location.href = sessionIdDodoInfo.url;
                  window.open(sessionIdDodoInfo.url, "_blank", "noopener,noreferrer");
                }
              break;

             case "paddle":
                const paddleSessionIdInfo = await createPaddleCustomerPortalSession(
                accountPaddleCustomerId,
                accountPaddleSubscriptionId,
                auth
              );
              if (paddleSessionIdInfo.url) {
                window.open(paddleSessionIdInfo.url, '_blank', "noopener,noreferrer");
              }
              break;

            default:
          }



      }
    } catch (error) {
      console.error("Error redirecting to Stripe portal:", error);
    } finally {
      setLoading(false);
    }
  };

  let planInfo = null;
  let basePrice = null;
  let finalPrice = null;

  if (accountStatus !== "canceled")
  {
    planInfo = accountSubscriptionPlan ? PLANS.planAdditionaInfo[accountSubscriptionPlan] : null;
    basePrice = accountSubscriptionPlan ? PLANS[accountSubscriptionFrequency][accountSubscriptionPlan].price : null;
    finalPrice = accountSubscriptionFrequency === "yearly" && basePrice ? (basePrice * 12).toFixed(2) : basePrice ? basePrice.toFixed(2) : null;
  }

  const livelyBackground = theme.palette.mode === 'light' ? colors.primary[600] : colors.primary[Math.max(50, 600 - 100)];

  return (
    <>
      <Box m="20px">
        <Header title="Subscriptions" subtitle="Manage your subscriptions" />
        <Box height="75vh">
          {accountSubscriptionType === "trial" ? (
            <Card sx={{ p: 3, textAlign: "center", backgroundColor: livelyBackground, borderRadius: "16px", boxShadow: 4 }}>
              <Typography variant="h5" gutterBottom>
                You are currently on a <strong>Free Trial</strong>
              </Typography>
              <Typography variant="body1" sx={{ mb: 3 }}>
                Click the button below to subscribe to a paid plan and unlock full access.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                size="large"
                href="/pricing"
                sx={{ fontWeight:600, fontSize:'15px', backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }}
              >
                Subscribe Now
              </Button>
            </Card>
          ) : planInfo ? (
            <Card sx={{ p: 3, backgroundColor: livelyBackground, borderRadius: "16px", boxShadow: 4 }}>
              <Typography variant="h4" gutterBottom>
                
                <p>Account Number: <span style={{fontWeight:600}}>{appUserAccountNumber}</span></p>

                <p>Current Plan: <span style={{fontWeight:600}}>{planInfo.title}</span></p>
              </Typography>
              <Divider sx={{ my: 2 }} />
              <Typography variant="h6" gutterBottom>
                Features:
              </Typography>
              <List>
                {planInfo.features.map((feature, index) => (
                  <ListItem key={index}>
                    <ListItemText primary={feature} />
                  </ListItem>
                ))}
              </List>
              <Divider sx={{ my: 2 }} />
              <Typography variant="body1" gutterBottom>
                <strong>Payment Frequency:</strong> {capitalize(accountSubscriptionFrequency)}
              </Typography>
              <Typography variant="body1" gutterBottom>
                <strong>Price:</strong> ${finalPrice} / {accountSubscriptionFrequency}
              </Typography>
              <Typography variant="body2" sx={{ mt: 2, mb: 2 }}>
                To manage all aspects of your subscription—including upgrades, payment info, and cancellations—click the button below. Once finished, you can return to the application.
              </Typography>
              <Button
                variant="contained"
                color="primary"
                size="large"
                sx={{ fontWeight:600, fontSize:'15px', backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }}
                onClick={goToCustomerPortal}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Manage Your Subscription"}
              </Button>
            </Card>
          ) : (
            <Typography variant="body1">No subscription plan information available.</Typography>
          )}
        </Box>
      </Box>
    </>
  );
};

export default Subscriptions;
